


// Products slider
$(document).ready(function() { 
  $(".product-slider").owlCarousel({ 
    autoPlay: false
  }); 
});


// Item link
$(document).ready(function() {
  $(".item-overlay").click(function(){
    window.location=$(this).find("a").attr("href"); 
    return false;
  });
});


// Accordion
$(document).ready(function () {
  $('ul.accordion').accordion();
});


// Mobile nav
$(document).ready(function(){      
  $('.drawer').drawer();  
});


// Modal windows
$(document).ready(function() {
  $(".fancybox").fancybox();
});


// Select dropdown
Select.init({selector: '.single-option-selector, .filter-by, .sort-by'})


// Parallax
$(document).ready(function(){  
  $window = $(window);
  $('div[data-type="background"]').each(function(){
    var $bgobj = $(this);
    $(window).scroll(function() {

      var yPos = -($window.scrollTop() / $bgobj.data('speed')); 
      var coords = '50% '+ yPos + 'px';

      $bgobj.css({ backgroundPosition: coords });

    });
  });	
}); 


// Go to top
$(document).ready(function($){

  var offset = 300,
      offset_opacity = 1200,
      scroll_top_duration = 700,
      $back_to_top = $('.to-top');

  $(window).scroll(function(){
    ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('to-is-visible') : $back_to_top.removeClass('to-is-visible to-fade-out');
    if( $(this).scrollTop() > offset_opacity ) { 
      $back_to_top.addClass('to-fade-out');
    }
  });

  $back_to_top.on('click', function(event){
    event.preventDefault();
    $('body,html').animate({
      scrollTop: 0 ,
    }, scroll_top_duration
                          );
  });

});


// sticky
$(document).ready(function(){
  if ($(window).width() > 1024) {
    $(".sticky").sticky({topSpacing:0});
  }
});



